import React, { useEffect, useState } from "react";
import ProtectedRoute from "../../components/protected-route";
import { ThemeProvider } from "@material-ui/core/styles";
import Dashboard from "./dashboard";
import Drawer from "../../components/drawer";
import { groupTheme } from "../../utils/theme/group";
import { menus } from "./menus";
import Header from "../../components/header";
import { useRouteMatch } from "react-router-dom";
import { logoutUser } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../context";
import Activity from "./activity";
import Participants from "./participants";
import withMiddleware from "../../middleware";
import { getUser, getAttributes } from "./handler";
import { updateUser } from "../../actions/app";
import Profile from "./user-profile";
import userReadings from "./user-readings";
// import GroupSwitch from "./group-switch";
import _ from "lodash";
import orgName from "../admin/organisation/org-name";
import OrgIcon from "../../assets/images/org.png";
import { useUtils } from "../../utils";
import { useMapping } from "../../hooks/useMapping";
import GroupInvitation from "./invitation";
import GroupUsers from "./users";
import { setCurrentOrg } from "../../components/header/handler";
import Reports from "../org/reports";
import GroupReports from "./reports";

function GroupHome(props) {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { showToast } = useUtils();
  const { canGoBackToOrg } = useMapping();
  const { user } = useSelector((state) => ({
    user: state.app.user,
  }));
  const { location, history, service } = props;
  const [menu, setMenu] = useState(menus);
  const options = [
    {
      id: 1,
      label: "Sign out",
    },
  ];

  useEffect(() => {
    // TODO: Work on the back to org or group menu item.
    const existIndex = _.findIndex(menu, { id: "back-to-org", title: "Back to Org" });
    if (canGoBackToOrg) {
      if (existIndex === -1) {
        const orgMenu = {
          id: "back-to-org",
          title: "Back to Org",
          path: "#",
          icon: OrgIcon,
        };
        setMenu((oldMenus) => {
          let newMenus = _.clone(oldMenus);
          newMenus.push(orgMenu);
          return newMenus;
        });
      }
    } else {
      if (existIndex) {
        setMenu((oldMenus) => {
          let newMenus = _.clone(oldMenus);
          delete newMenus[existIndex];
          return newMenus;
        });
      }
    }
  }, [canGoBackToOrg]);

  // async function reFetchUser() {
  //   try {
  //     // TODO: Improve this logic and make it work with if user can switch to org or not.
  //     if (location.state && location.state.fromOrg) {
  //       updateMenu();
  //     }
  //     const user = await getUser(service);
  //     dispatch(updateUser(user));
  //   } catch (err) {
  //     showToast("error", err.message);
  //   }
  // }

  function signOut(id) {
    dispatch(logoutUser());
  }

  return (
    <ThemeProvider theme={groupTheme}>
      {user ? (
        <UserContext.Provider value={user}>
          <Drawer
            menuItems={menu}
            onChangeMenu={(menuItem) => {
              if (menuItem?.id == "back-to-org") {
                setCurrentOrg(service, {
                  currentUserType: "org",
                  currentOrgId: String(user?.current_org_id),
                  currentGroupId: String(user?.current_group_id),
                }).then(() => {
                  history.replace("/org");
                });
              }
            }}
          />
          <Header
            dash_name="Group > "
            attr={getAttributes(location)}
            options={options}
            history={history}
            // otherComponents={<GroupSwitch />}
            onMenuClick={(id) => signOut(id)}
          />
          <ProtectedRoute exact path={path} component={Dashboard} />
          <ProtectedRoute exact path={`${path}/participants`} component={GroupUsers} />
          <ProtectedRoute exact path={`${path}/participants/profile`} component={Profile} />
          <ProtectedRoute exact path={`${path}/participants/readings`} component={userReadings} />
          <ProtectedRoute exact path={`${path}/invitation`} component={GroupInvitation} />
          <ProtectedRoute exact path={`${path}/activity`} component={Activity} />
          <ProtectedRoute exact path={`${path}/reports`} component={GroupReports} />
        </UserContext.Provider>
      ) : (
        <div />
      )}
    </ThemeProvider>
  );
}

export default withMiddleware(GroupHome);
